import { render, staticRenderFns } from "./RolesHead.vue?vue&type=template&id=017bed86"
import script from "./RolesHead.vue?vue&type=script&lang=js"
export * from "./RolesHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports